import React from 'react';
import BestSupport from 'assets/images/billing/awards/best-support.svg';
import LeaderFall from 'assets/images/billing/awards/leader-fall.svg';
import MidMarketLeader from 'assets/images/billing/awards/mid-market-leader.svg';
import MomentumLeader from 'assets/images/billing/awards/momentum-leader.svg';
import SmallBusinessLeader from 'assets/images/billing/awards/small-business-leader.svg';
import styles from './styles.module.scss';

const AwardSection = () => (
  <div className={styles.awardSectionWrapper}>
    <div className={styles.awardContent}>
      Trivia in G2&apos;s Grid Report for
      <br /> Productivity Bots, Fall 2022.
    </div>
    <div className={styles.awardsImagesWrapper}>
      <img className={styles.awards} src={BestSupport} alt='Awards' />
      <img className={styles.awards} src={LeaderFall} alt='Awards' />
      <img className={styles.awards} src={MidMarketLeader} alt='Awards' />
      <img className={styles.awards} src={SmallBusinessLeader} alt='Awards' />
      <img className={styles.awards} src={MomentumLeader} alt='Awards' />
    </div>
  </div>
);

export default AwardSection;
